'use client';

import { Component, createContext, ErrorInfo, ReactNode } from 'react';
import { translateInline } from '../translate/translateInline';

export const ErrorFallback = () => {
	return (
		<p>
			{translateInline({
				en: 'This component could not be loaded, please try again later.',
				nl: 'Dit onderdeel kon niet worden ingeladen, probeer het later nog eens.',
			})}
		</p>
	);
};

export const ErrorBoundaryContext = createContext<Error | undefined>(undefined);

type ErrorBoundaryProps = {
	children: ReactNode;
	fallback: ReactNode;
};

/**
 * ErrorBoundary component to catch errors in the component tree.
 * It uses ErrorBoundaryContext to provide the error to the fallback component.
 */
export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	{ didCatch: true; error: Error } | { didCatch: false }
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);

		this.state = { didCatch: false };
	}
	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		this.setState({ didCatch: true, error });
		console.error(error, errorInfo);
	}
	render(): ReactNode {
		return this.state.didCatch ? (
			<ErrorBoundaryContext value={this.state.error}>
				{this.props.fallback}
			</ErrorBoundaryContext>
		) : (
			this.props.children
		);
	}
}
